<template>
  <div>
    <ReplicationForm v-if="canShowFieldsBasedOnSessionType(newSession.type, [...repriseSessionType, 'SOINS', 'HORS_MONTOIR'])" />
    <v-row class="p0-16">
      <v-col cols="4">
        <div v-if="placesLoading" class="d-flex justify-center align-center full-height pa-4">
          <Loader />
        </div>
        <ContentTypeField
          v-else-if="canShowField('place')"
          v-model="place"
          title="Lieu de pratique"
          content-type-field="place_name"
          :availables-content-type="getAvailablePlaces"
          :update-session="updateSession"
          icon="mdi-plus"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, ref, watch, onBeforeMount, inject } from '@vue/composition-api';
import { isObjectEmpty, canShowFieldsBasedOnSessionType, repriseSessionType } from '../../../helpers/utils';
import { verifyDragAndDropExceptions } from '../../../helpers/dragAndDrop';
import ContentTypeField from './ContentTypeField.vue';
import Loader from '@/components/common/Loader.vue';
import store from '@/store';
import ReplicationForm from './replication/ReplicationForm.vue';

export default {
  components: { ContentTypeField, ReplicationForm, Loader },
  props: {
    placesLoading: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const newSession = inject('newSession');
    const places = computed(() => store.state.places);

    const place = ref({});

    const getAvailablePlaces = computed(() => store.getters.availablePlaces(newSession.value));

    const getSessionPlace = session => store.getters.sessionPlace(session);

    const populateSessionResources = () => {
      // reset values
      const placeObject = getSessionPlace(newSession.value);
      place.value = placeObject || null;
    };

    onBeforeMount(() => {
      populateSessionResources();
    });

    // v-model
    watch(newSession, () => {
      populateSessionResources();
    });

    const updateSession = () => {
      context.emit('update-session-content-type', {
        place: place.value,
      });
    };

    const canShowField = type => verifyDragAndDropExceptions(newSession.value, type);

    return { repriseSessionType, canShowField, canShowFieldsBasedOnSessionType, newSession, place, places, isObjectEmpty, updateSession, getAvailablePlaces };
  }
};
</script>
